import React from 'react';
import { Search, Shield, TrendingUp } from 'lucide-react';

const FeatureSection = () => {
  const features = [
    {
      id: 1,
      icon: Search,
      title: 'Comprehensive Trademark Search',
      description: 'Our AI-powered search technology scans millions of existing trademarks to identify potential conflicts before you file. We conduct federal, state, and common law searches to ensure your brand name, logo, or slogan is available for registration, saving you time and avoiding costly rejections.',
      image: 'https://images.unsplash.com/photo-1758518731457-5ef826b75b3b?q=80&w=2670&auto=format&fit=crop',
      reverse: false
    },
    {
      id: 2,
      icon: Shield,
      title: 'Complete Registration & Filing',
      description: 'We handle the entire trademark registration process from application preparation to USPTO filing. Our experienced trademark attorneys review your application, select the appropriate classes, craft compelling descriptions, and respond to office actions to maximize your chances of approval.',
      image: 'https://images.unsplash.com/photo-1758518731462-d091b0b4ed0d?q=80&w=2670&auto=format&fit=crop',
      reverse: true
    },
    {
      id: 3,
      icon: TrendingUp,
      title: 'Ongoing Brand Protection',
      description: 'Protect your trademark with continuous monitoring services that alert you to potential infringers. We track new trademark applications, domain registrations, and online marketplaces to identify unauthorized use of your brand, and provide enforcement guidance to defend your intellectual property rights.',
      image: 'https://images.unsplash.com/photo-1562564055-71e051d33c19?q=80&w=2669&auto=format&fit=crop',
      reverse: false
    }
  ];

  return (
    <div className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {features.map((feature, index) => (
          <div
            key={feature.id}
            className={`flex flex-col ${feature.reverse ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-6 md:gap-12 mb-16 md:mb-32 last:mb-0`}
          >
            {/* Image Side */}
            <div className="w-full md:w-1/2">
              <div className="relative">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="rounded-2xl shadow-2xl w-full h-auto"
                />
              </div>
            </div>

            {/* Content Side */}
            <div className="w-full md:w-1/2">
              <div className="mb-6">
                <div className="w-16 h-16 bg-black rounded-2xl flex items-center justify-center mb-6 transition-transform duration-300 hover:scale-110 hover:rotate-6">
                  <feature.icon className="w-8 h-8 text-[#FF035B]" />
                </div>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-black mb-6">
                {feature.title}
              </h2>
              <p className="text-base text-gray-700 leading-relaxed">
                {feature.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeatureSection;